import { jwtDecode } from "jwt-decode";
import { AppJwtPayload } from "../types/customTypes";

export enum UserRole {
  ROOT = "ROOT",
  ORGANIZATION_ADMIN = "ORGANIZATION_ADMIN",
  CALLCENTER = "CALLCENTER",
  OPERATOR = "OPERATOR",
  SHIFT_PLANNER = "SHIFT_PLANNER",
  CONTROL_CENTER_STAFF = "CONTROL_CENTER_STAFF",
  DISPATCHER = "DISPATCHER",
}

export const CALLCENTER_USER_ROLES = [
  UserRole.ROOT,
  UserRole.ORGANIZATION_ADMIN,
  UserRole.CALLCENTER,
];

export function getTokenPayload(token: string): AppJwtPayload {
  return jwtDecode<AppJwtPayload>(token);
}

export function getRoleFromToken(token: string): string {
  return getTokenPayload(token).Role;
}

export function getOrganizationIdFromToken(
  token: string | null,
): string | null {
  if (!token) return null;
  return getTokenPayload(token).OrganizationId;
}
